import React from 'react';

const Left = () => (
    <>
        JD Sports Fashion Plc
        <br />
        (Registered in England & Wales with number 1888425)
        <br />
        <br />
        Registered office:
        <br />
        Hollinsbrook Way
        <br />
        Pilsworth, Bury
        <br />
        Lancashire
        <br />
        BL9 8RR
        <br />
        <br />
        Telephone:
        <br />
        +44 161 767 1000
    </>
);
const Right = () => (
    <>
        Investor relations queries:
        <br />
        <a className="mail" href="mailto:investor.relations@jdplc.com">
            investor.relations@jdplc.com
        </a>
        <br />
        <br />
        General queries:
        <br />
        <a className="mail" href="mailto:info@jdplc.com">
            info@jdplc.com
        </a>
        <br />
        <br />
        HR Advice:
        <br />
        <a className="mail" href="mailto:HRAdvice@jdplc.com">
            HRAdvice@jdplc.com
        </a>
        <br />
        <br />
        The JD Foundation enquiries:
        <br />
        <a className="mail" href="mailto:thejdfoundation@jdplc.com">
            thejdfoundation@jdplc.com
        </a>
    </>
);

export const content = {
    left: Left,
    right: Right,
};
